
import { Typography, Button } from "../../components"
import "./styles.css";

import onderbouwingsubsidieverzoek from '../../assets/documents/library/onderbouwingsubsidieverzoek2026.pdf';

export default function OnderbouwingSubsidieverzoek(props) {
    return (
        <div className='container'>
            <Typography type='h1' style={{ color: 'var(--trust)', fontSize: '2.2em' }}>Onderbouwing subsidieverzoek</Typography>
            <div className="button-container">
                <Button 
                    target='_blank' 
                    href={onderbouwingsubsidieverzoek} 
                    text={`Klik hier voor ons ondersteundend subsidiedocument`}
                />
            
                <Button 
                    target='_blank' 
                    href={"/media/prof/stappenplan-subsidie/document/digital.pdf"} 
                    text={`Klik hier voor een stappenplan ter ondersteuning van de subsidieaanvraag`}
                />  
            </div>
        </div>
    )
}
